/* eslint-disable prettier/prettier */

import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { useSelector } from "react-redux";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MDTypography from "components/MDTypography";
import { useState } from "react";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

function StepperImagenes() {
  const theme = useTheme();
  const { detalleSolicitud } = useSelector((state) => state.solicitud);

  const [activeStep, setActiveStep] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [autoPlayActivo, setAutoPlayActivo] = useState(true);

  const maxSteps = detalleSolicitud.galeria?.length || 0;

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
    setAutoPlayActivo(true);
  };
  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
    setAutoPlayActivo(true);
  };
  const handleStepChange = (step) => setActiveStep(step);

  const handleOpenModal = (mediaSrc) => {
    setModalImage(mediaSrc);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalImage(null);
  };

  return (
    <>
      <Box
        sx={{
          maxWidth: 600,
          width: "100%",
          mx: "auto",
          backgroundColor: "#1A2035",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
          overflow: "hidden",
        }}
      >
        <AutoPlaySwipeableViews
          autoplay={autoPlayActivo}
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {detalleSolicitud.galeria.map((step, index) => {
            const imgURL = step.imagenBase64;
            return (
              <div key={step.idGaleria}>
                {Math.abs(activeStep - index) <= 2 && (
                  <Box sx={{ position: "relative" }}>
                    {imgURL.startsWith("data:video") ||
                    imgURL.startsWith("data:application/octet-stream") ? (
                      <video
                        src={
                          imgURL.startsWith("data:application/octet-stream")
                            ? imgURL.replace("data:application/octet-stream", "data:video/mp4")
                            : imgURL
                        }
                        controls
                        style={{
                          height: 400,
                          width: "100%",
                          objectFit: "cover",
                        }}
                        onWaiting={() => setAutoPlayActivo(false)}
                        onPlay={() => setAutoPlayActivo(false)}
                        onPause={() => setAutoPlayActivo(true)}
                        onEnded={() => setAutoPlayActivo(true)}
                      />
                    ) : (
                      <Box
                        component="img"
                        src={imgURL}
                        alt={step.galeriaNombre}
                        sx={{
                          height: 400,
                          width: "100%",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleOpenModal(imgURL);
                          setAutoPlayActivo(false);
                        }}
                      />
                    )}
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        bgcolor: "rgba(0, 0, 0, 0.5)",
                        px: 2,
                        py: 1,
                      }}
                    >
                      <MDTypography variant="body2" color="white">
                        {step.galeriaNombre} — {new Date(step.fechaFoto).toLocaleDateString()}
                      </MDTypography>
                    </Box>
                  </Box>
                )}
              </div>
            );
          })}
        </AutoPlaySwipeableViews>

        <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={activeStep === maxSteps - 1}
              sx={{ color: "#fff" }}
            >
              Siguiente
              {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
              sx={{ color: "#fff" }}
            >
              {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
              Atrás
            </Button>
          }
          sx={{
            bgcolor: "#111827",
            ".MuiMobileStepper-dot": { backgroundColor: "#fff" },
            ".MuiMobileStepper-dotActive": { backgroundColor: "#ffa726" },
          }}
        />
      </Box>

      {/* MODAL PARA IMAGEN AMPLIADA */}
      <Modal open={openModal} onClose={handleCloseModal} closeAfterTransition>
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0,0,0,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
          }}
        >
          <IconButton
            onClick={() => {
              handleCloseModal();
              setAutoPlayActivo(true);
            }}
            sx={{ position: "absolute", top: 20, right: 20, color: "#fff" }}
          >
            <CloseIcon fontSize="large" />
          </IconButton>
          <Box
            component="img"
            src={modalImage}
            alt="Vista ampliada"
            sx={{
              maxHeight: "90%",
              maxWidth: "90%",
              borderRadius: "10px",
              boxShadow: "0 0 20px rgba(255,255,255,0.3)",
            }}
          />
        </Box>
      </Modal>
    </>
  );
}

export default StepperImagenes;
